import http from '@/utils/http';

/**
 * 拉取休闲游戏品类画像数据
 * @param type 业务类型
 * @param data 接口入参
 * @param params 查询参数
 * @param cancelToken axios CancelToken，用于取消请求
 */
export const fetchCasualGenreProfileMetrics = (
  type: string,
  data: ICasualGenreProfileFetchParams,
  params?: IRecord,
  cancelToken?: any,
): IBaseResponse<IPaginationData<ICasualGenreProfileMetricData>> => {
  return http({
    url: '/api/v1/intelligence_pc/game/genre_profile/metrics',
    method: 'post',
    cancelToken,
    data,
    params: {
      ...params,
      type,
    },
    rawData: true,
  }) as any;
};
